import * as Buttons from '../button/button.selectors';
import * as Controls from '../control/controls.selectors';
import * as Modal from '../modal/modal.selectors';
import Snackbar from '../snackbar/snackbar.selectors';
import {LoaderSelector} from '../loader/loader.selectors';
import {TooltipSelectors} from '../tooltip/selectors';

export default {
	Buttons: Buttons.Selectors,
	Controls: Controls.Selectors,
	Loader: LoaderSelector,
	Modal: Modal.Selectors,
	Snackbar: Snackbar,
	Tooltips: TooltipSelectors,
};
